import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import earth from "../Images/earth.jpg"; 
import { Grid, Button, Box, Typography, Fade } from "@mui/material";
import logoImage from "../Images/tw logo.svg";
import "typeface-poppins";
import "typeface-raleway";

const Page6 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Capitalize first letter of name
  const capitalizeFirstLetter = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const fullName = capitalizeFirstLetter(location.state?.fullName || 'Guest');
  const companyName = location.state?.companyName || '';

  // Redirect if no state is passed
  useEffect(() => {
    if (!location.state?.fullName) {
      navigate('/');
    }
  }, [location.state, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        maxWidth: "100%",
        margin: "0 auto",
        backgroundImage: `url(${earth})`,
        backgroundSize: "cover",
        backgroundPosition: "52.5% center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        textAlign: "center",
        overflow: "hidden"
      }}
    >
      {/* Navbar */}
      <Grid
        container
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "10px 20px",
          zIndex: 10,
        }}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Logo */}
        <Grid item>
          <Box
            component="img"
            src={logoImage}
            alt="Towerwatch Logo"
            onClick={handleLogoClick}
            sx={{
              height: "30px",
              objectFit: "contain",
              cursor: "pointer"
            }}
          />
        </Grid>

        {/* Join Button */}
        <Grid item>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              fontSize: "10px",
              fontWeight: "regular",
              textTransform: "none",
              width: "78px",
              height:"27px",
              fontFamily: "Raleway",
              padding: "8px 16px",
              borderRadius: "10px",
              border: "1px solid #FFFFFF",
              "&:hover": {
                backgroundColor: "#fff",
                color: "#00d8ff",
              },
            }}
          >
            Join us
          </Button>
        </Grid>
      </Grid>

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#2f2f2f",
          opacity: 0.6,
          zIndex: 1,
        }}
      />

      {/* Gradient Overlays */}
      <Box
        sx={{
          position: "absolute",
          bottom: -5,
          left: 0,
          right: 0,
          height: "507px", 
          background: "linear-gradient(to top, black, transparent)", 
          zIndex: 2, 
        }}
      />
      
      <Box
        sx={{
          position: "absolute",
          top: -5,
          left: 0,
          right: 0,
          height: "507px", 
          background: "linear-gradient(to bottom, black, transparent)", 
          zIndex: 2, 
        }}
      />
      
      {/* Content */}
      <Fade in={true} timeout={1000}>
        <Box sx={{ zIndex: 3, padding: "20px", textAlign: "center" }}>
          <Typography
            sx={{
              color: "white",
              fontSize: "42px",
              fontWeight: "medium",
              marginBottom: "10px",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
              fontFamily: "Raleway, sans-serif",
              lineHeight: "1.2",
              marginBottom: "40px",   
            }}
          >
            Thanks For <br />
            <span style={{ color: "#00bfff" }}>Joining With Us</span>
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontSize: "20px",
              marginBottom: "20px",
              fontWeight: "normal",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            Thank You For Joining The Waitlist,{" "}
            <span style={{ 
              color: "#00bfff", 
              fontFamily: 'raleway', 
              fontWeight: "regular",
              fontSize: "25px", 
            }}>
              {fullName}!
            </span>
          </Typography>

          {companyName && (
            <Typography
              variant="body2"
              sx={{
                color: "#FFFFFF",
                fontSize: "24px",
                marginBottom: "20px",
                fontFamily: "Raleway, sans-serif",
              }}
            >
              From <span style={{color: "#00bfff"}}>{companyName}
              </span>
            </Typography>
          )}

          <Typography
            variant="body1"
            sx={{
              color: "white",
              fontSize: "17px",
              fontWeight: "normal",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)",
              fontFamily: "Raleway, sans-serif",
              lineHeight: "1.5",
              marginTop: '40px'
            }}
          >
            We're Excited To Have You With Us. Stay Tuned For Updates <br></br>
            You're One Step Closer To Experiencing TowerWatch Firsthand!
          </Typography>
        </Box>
      </Fade>
    </Box>
  );
};

export default Page6;